import 'date-fns'
import React, { useEffect, useRef } from 'react'
import Grid from '@material-ui/core/Grid'

import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDateTimePicker, KeyboardDatePicker } from '@material-ui/pickers'
import ptBRLocale from 'date-fns/locale/pt-BR'

export const SelecionarData = (props) => {
  const { dataBD, callback, label, required, minDate, name, disabled, withoutTime, maxDate, shrink, md, sm, lg, xs } = props
  const [selectedDate, setSelectedDate] = React.useState(dataBD)

  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  })

  React.useEffect(() => {
    if (disabled) {
      setSelectedDate(null)
      if (callbackRef.current) {
        callbackRef.current(null)
      }
    }
  }, [disabled])

  useEffect(() => {
    setSelectedDate(dataBD)
  }, [dataBD])

  const handleDateChange = (date) => {
    if (withoutTime && date) date.setHours(0, 0, 0, 0)
    setSelectedDate(date)
    if (callback) {
      callback(date)
    }
  }
  const commonProps = {
    disabled:disabled,
    variant:"inline",
    inputVariant:"outlined",
    ampm:false,
    format:'dd/MM/yyyy',
    minDate:minDate,
    maxDate:maxDate || Date.now(),
    minDateMessage:"Selecione uma data posterior a ação anterior",
    maxDateMessage:"Selecione uma data anterior ao dia máximo possível",
    id:label,
    label:label,
    value:selectedDate || null,
    onChange:handleDateChange,
    KeyboardButtonProps:{
      'aria-label': 'change date',
    },
    InputLabelProps:{
      shrink: true,
      style: shrink ? { fontSize: '16px' } : null,
    },
    required:required === true,
    name:name,
    fullWidth: true,
  }
  
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
      <Grid container item md={md} sm={sm} lg={lg} xs={xs}>
        {withoutTime ? <KeyboardDatePicker {...commonProps} /> : <KeyboardDateTimePicker {...commonProps} format={'dd/MM/yyyy  HH:mm'} />}
      </Grid>
    </MuiPickersUtilsProvider>
  )
}
